import { c as _c } from "react/compiler-runtime";
import { useTranslation } from 'react-i18next';
const useRegistrationStatusText = () => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      keyPrefix: "onboardings.registrations.status"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation("entity-details", t0);
  let t1;
  if ($[1] !== t) {
    t1 = status => {
      if (status === "unknown") {
        return t(_temp);
      }
      if (status === "active") {
        return t(_temp2);
      }
      if (status === "inactive") {
        return t(_temp3);
      }
    };
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export default useRegistrationStatusText;
function _temp($) {
  return $.unknown;
}
function _temp2($_0) {
  return $_0.active;
}
function _temp3($_1) {
  return $_1.inactive;
}